import { DEFAULT_CURRENCY_CODE, InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
// import { MenuComponent } from './menu/menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WebinarsComponent } from './webinars/webinars.component';
import { ProductsComponent } from './products/products.component';
import { CartComponent } from './cart/cart.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FooterComponent } from './footer/footer.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MaterialModuleModule } from './material-module/material-module.module';
import { PoliciesComponent } from './policies/policies.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { TermConditionsComponent } from './term-conditions/term-conditions.component';
import { PaymentPolicyComponent } from './payment-policy/payment-policy.component';
import { ShippingPolicyComponent } from './shipping-policy/shipping-policy.component';
import { DisputePolicyComponent } from './dispute-policy/dispute-policy.component';
import { HostingTermsComponent } from './hosting-terms/hosting-terms.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { PrimeNgModule } from './prime-ng/prime-ng.module';
import { API_BASE_URL, CartClient, ContactUsClient, FacebookClient, FaqClient, HostPortalClient, InterestedHostClient, MyAccountClient, PaymentClient, PlatformChargesClient, UserClient, WebinarClient, WebinarRunClient } from './Services/WOWApi.Service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonServices } from './Common/CommonServices';

import { CheckUserLogin } from './Common/check-user-login';
import { CreateWebinarComponent } from './create-webinar/create-webinar.component';
import { WebinarComponent } from './webinar/webinar.component';
import { CustomServiceService , API_BASE_URL1 } from './Services/custom-service.service';
import { PurchaseSeatsComponent } from './purchase-seats/purchase-seats.component';
// import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { StoreModule } from '@ngrx/store';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { WebinarRoomsComponent } from './webinar-rooms/webinar-rooms.component';
import { SpinnerComponent } from './Shared/spinner/spinner.component';
import { PromoTickerComponent } from './Shared/promo-ticker/promo-ticker.component';
import { HttpAuthTokenInterceptor } from './Common/http-auth-token.interceptor';
import { AboutUsComponent } from './about-us/about-us.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { PurchaseHistoryTableComponent } from './Shared/purchase-history-table/purchase-history-table.component';
import { CardPaymentDetailsComponent } from './Shared/card-payment-details/card-payment-details.component';
import { UserAddressComponent } from './Shared/user-address/user-address.component';
import { CommunicationMethodsComponent } from './my-account/communication-methods/communication-methods.component';
import { HostSignUpComponent } from './host-sign-up/host-sign-up.component';
import { WinningWebinarTableComponent } from './Shared/winning-webinar-table/winning-webinar-table.component';
import { VideoPopupComponent } from './Shared/video-popup/video-popup.component';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';

import { LoginLayoutComponent } from './layout/login-layout/login-layout.component';
import { HostDashboardComponent } from './HostPort/host-dashboard/host-dashboard.component';
import { MyWebinarQueueComponent } from './HostPort/my-webinar-queue/my-webinar-queue.component';
import { MyConfigurationComponent } from './HostPort/my-configuration/my-configuration.component';
import { OutOfOfficeComponent } from './HostPort/out-of-office/out-of-office.component';
import { VideoRecordingService } from './create-webinar/video-recording-service';

import { FormatTimePipe } from './CustomPipe/format-time.pipe';
import { WebinarRunComponent } from './webinar-run/Dashboard/webinar-run.component';
import { WebinarRunDemoComponent } from './webinar-run/demo/webinar-run-demo.component';
import { WebinarCountdownComponent } from './webinar-run/countdown/webinar-countdown.component';
import { PlayVideoComponent } from './webinar-run/VideoPlay/play-video/play-video.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserSeatComponent } from './webinar-run/UserSeat/user-seat/user-seat.component';
import { DisplayResultsComponent } from './webinar-run/display-results/display-results.component';
import { CongratulationsPopupComponent } from './webinar-run/congratulations-popup/congratulations-popup.component';
import { MyStatsComponent } from './HostPort/my-stats/my-stats.component';
import { CheckHost } from './Common/check-host';
import { API_BASE_URL2, SignalrService } from './Services/signalr.service';
import { API_BASE_URLRUN } from './Services/webinar-run.service';
import { MyShipmentsComponent } from './HostPort/my-shipments/my-shipments.component';
import { FromAddressDialogComponent } from './HostPort/my-shipments/from-address-dialog.component';
import { TrackingDialogComponent } from './HostPort/my-shipments/tracking-dialog.component';
import { WebinarHistoricalComponent } from './HostPort/webinar-historical/webinar-historical.component';
import { ShareWebinarDialogComponent } from './HostPort/share-webinar-dialog/share-webinar-dialog.component';
import { RewatchWebinarComponent } from './rewatch-webinar/rewatch-webinar.component';
import { InterestedHostApprovalComponent } from './interested-host-approval/interested-host-approval.component';
import { FflImagesComponent } from './ffl-images/ffl-images.component';
import { OwnersPortalComponent } from './owners-portal/owners-portal.component';
import { CheckOwner } from './Common/check-owner';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { VeemPaymentComponent } from './payments/veem-payment/veem-payment.component';
import { SpinnerInterceptor } from './interceptor/spinner.interceptor';
import { SelectiveSpinnerInterceptor } from './interceptor/selective-spinner.interceptor';
import { EditPlatformChargeComponent } from './owners-portal/edit-platform-charge/edit-platform-charge.component';
import { HostAccountDetailComponent } from './HostPort/host-account-detail/host-account-detail.component';
import { EditHostAccountDetailComponent } from './HostPort/edit-host-account-detail/edit-host-account-detail.component';
import { WebinarSettlementComponent } from './owners-portal/webinar-settlement/webinar-settlement.component';
import { CompletedWebinarSettlementComponent } from './owners-portal/completed-webinar-settlement/completed-webinar-settlement.component';
import { CreateSettlementComponent } from './owners-portal/create-settlement/create-settlement.component';
import { AddLuckyBucksComponent } from './owners-portal/add-lucky-bucks/add-lucky-bucks.component';
import { UpdateImageComponent } from './HostPort/update-image/update-image.component';
import { FormatCreditCardDirective } from './directives/format-credit-card.directive';
import { environment } from 'src/environments/environment';
import { ConfigurationSettings } from './configuration-settings';
import { DecimalvaluesDirective } from './directives/decimalvalues.directive';
import { FilterDetailsPipe } from './Shared/pipes/filter-details.pipe';
import { InterestedHostInfoComponent } from './interested-host-approval/interested-host-info/interested-host-info.component';
import { EmailVerificationComponent } from './verification/email-verification/email-verification.component';
import { MenuComponent } from './Menu/menu.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneNumberDirective } from './directives/phone-number.directive';
import { NumbersonlyDirective } from './directives/numbersonly.directive';
import { TaxNumberDirective } from './directives/tax-number.directive';
import { FormatSsnNumberDirective } from './directives/format-ssn-directive';
import { FormatTaxIdDirective } from './directives/format-taxid-directive';
import { PyamentMethodsComponent } from './Shared/pyament-methods/pyament-methods.component';
import { AddUpdatePaymentMethodComponent } from './Shared/add-update-payment-method/add-update-payment-method.component';
import { WebinarImagesComponent } from './webinar/webinar-images/webinar-images.component';
import { FacebookPostComponent } from './facebook-post/facebook-post.component';
import { TwoDecimalOnlyDirective } from './directives/two-decimal-only.directive';
import { NumbersonlyNotStartingFromZeroDirective } from './directives/numbersonly-not-starting-from-zero.directive';
import { TwoDecimalWithMaxLimitDirective } from './directives/two-decimal-with-max-limit.directive';
import { HumanNamesDirective } from './directives/human-names-.directive';
import { CityValidatorDirective } from './directives/city-validator.directive';


@NgModule({ declarations: [
        AppComponent,
        LayoutComponent,
        MenuComponent,
        WebinarsComponent,
        ProductsComponent,
        CartComponent,
        FaqsComponent,
        FooterComponent,
        PoliciesComponent,
        RefundPolicyComponent,
        PaymentPolicyComponent,
        ShippingPolicyComponent,
        DisputePolicyComponent,
        HostingTermsComponent,
        TermConditionsComponent,
        HowItWorksComponent,
        ContactUsComponent,
        LoginComponent,
        RegisterComponent,
        CreateWebinarComponent,
        WebinarComponent,
        PurchaseSeatsComponent,
        WebinarRoomsComponent,
        SpinnerComponent,
        PromoTickerComponent,
        AboutUsComponent,
        MyAccountComponent,
        PurchaseHistoryTableComponent,
        CardPaymentDetailsComponent,
        UserAddressComponent,
        CommunicationMethodsComponent,
        HostSignUpComponent,
        WinningWebinarTableComponent,
        LoginLayoutComponent,
        HostDashboardComponent,
        MyWebinarQueueComponent,
        MyConfigurationComponent,
        OutOfOfficeComponent,
        WebinarRunComponent,
        WebinarRunDemoComponent,
        WebinarCountdownComponent,
        FormatTimePipe,
        PlayVideoComponent,
        UserSeatComponent,
        DisplayResultsComponent,
        CongratulationsPopupComponent,
        MyStatsComponent,
        MyShipmentsComponent,
        WebinarHistoricalComponent,
        ShareWebinarDialogComponent,
        RewatchWebinarComponent,
        InterestedHostApprovalComponent,
        FflImagesComponent,
        OwnersPortalComponent,
        ConfirmDialogComponent,
        VeemPaymentComponent,
        EditPlatformChargeComponent,
        HostAccountDetailComponent,
        EditHostAccountDetailComponent,
        WebinarSettlementComponent,
        CompletedWebinarSettlementComponent,
        CreateSettlementComponent,
        AddLuckyBucksComponent,
        UpdateImageComponent,
        FormatCreditCardDirective,
        DecimalvaluesDirective,
        FilterDetailsPipe,
        InterestedHostInfoComponent,
        EmailVerificationComponent,
        VideoPopupComponent,
        PhoneNumberDirective,
        NumbersonlyDirective,
        TaxNumberDirective,
        FormatSsnNumberDirective,
        FormatTaxIdDirective,
        PyamentMethodsComponent,
        AddUpdatePaymentMethodComponent,
        WebinarImagesComponent,
        FacebookPostComponent,
        FromAddressDialogComponent,
        TrackingDialogComponent,
        TwoDecimalOnlyDirective,
        NumbersonlyNotStartingFromZeroDirective,
        TwoDecimalWithMaxLimitDirective,
        HumanNamesDirective,
        CityValidatorDirective
    ],
    schemas: [NO_ERRORS_SCHEMA],
    bootstrap: [AppComponent], imports: [StoreModule.forRoot({}),
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        MatNativeDateModule,
        MaterialModuleModule,
        PrimeNgModule,
        FormsModule,
        ReactiveFormsModule,
        // OwlDateTimeModule,
        // OwlNativeDateTimeModule,
        BrowserAnimationsModule,
        MatIconModule,
        MatButtonModule,
        MatSidenavModule,
        MatToolbarModule,
        NgbModule,
        MatDialogModule
        ], 
    providers: [
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
        { provide: API_BASE_URL, useValue: ConfigurationSettings.API_URL },
        { provide: API_BASE_URL1, useValue: ConfigurationSettings.API_URL },
        { provide: API_BASE_URL2, useValue: ConfigurationSettings.API_URL },
        { provide: API_BASE_URLRUN, useValue: ConfigurationSettings.API_URL },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
        { provide: HTTP_INTERCEPTORS, useClass: HttpAuthTokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SelectiveSpinnerInterceptor, multi: true },
        CommonServices,
        CheckUserLogin,
        CheckOwner,
        CheckHost,
        UserClient,
        FaqClient,
        WebinarClient,
        InterestedHostClient,
        CartClient,
        CustomServiceService,
        MyAccountClient,
        ContactUsClient,
        HostPortalClient,
        VideoRecordingService,
        PaymentClient,
        WebinarRunClient,
        SignalrService,
        PlatformChargesClient,
        FacebookClient,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
